import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Box, Card, CardContent, CardHeader, FormControl, Grid, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { HashUnit } from '../../../abelcommon';
import { useHashrateRevenueCalculator } from '../../../abelcommon/hooks/useHashrateRevenueCalculator';
import { useTranslation } from 'react-i18next';

export const HashRateCalculatorSection = ({ abelPrice }: { abelPrice: number }) => {
  const [hashRate, setHashRate] = useState('');

  const { data: revenuePerDay } = useHashrateRevenueCalculator([+hashRate], HashUnit.MH, abelPrice);
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader title={t('hashRateCalculatorSectionPage.hashRateCalculator')} />
      <CardContent sx={{ overflow: 'auto', fontWeight: 500 }}>
        <Typography variant="body2" sx={{ mb: 3, fontWeight: 500, color: 'error.main' }}>
          {t('hashRateCalculatorSectionPage.warningCalculator')}
        </Typography>
        <Grid container spacing={1} xl={12} sx={{ mx: 'auto' }}>
          <Grid item xs={12} md={5}>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
              <Box component="img" src="abel-icon-blue.png" sx={{ height: 18, width: 18, mr: 1 }} /> ABEL
              <TextField
                sx={{ ml: 1 }}
                label={t('hashRateCalculatorSectionPage.hashRate')}
                color="info"
                value={hashRate}
                onChange={(e) => {
                  if (e.target.value === '') setHashRate('');
                  else if (!isNaN(+e.target.value.trim())) setHashRate(e.target.value.trim());
                }}
              />
              <Box sx={{ ml: 1 }}>Mh/s</Box>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={2} sx={{ alignSelf: 'center', textAlign: 'center' }}>
            <ArrowForwardIcon />
          </Grid>
          <Grid item xs={12} md={5}>
            <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
              <TextField
                label={t('hashRateCalculatorSectionPage.revenue')}
                value={!hashRate ? '' : revenuePerDay.length === 0 ? 0 : revenuePerDay[0].revenue}
                sx={{ ml: 1 }}
                InputProps={{ readOnly: true }}
                focused={false}
              />
              <Box sx={{ ml: 1 }}>ABEL/{t('hashRateCalculatorSectionPage.day')}</Box>
              <Box sx={{ ml: 1 }}>
                {' '}
                ≈ {!hashRate ? '????' : revenuePerDay.length === 0 ? 0 : revenuePerDay[0].revenueUSD} USD/
                {t('hashRateCalculatorSectionPage.day')}
              </Box>
            </FormControl>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
